export function SectionLabel({ children, className = '' }) {
  return (
    <p
      className={`font-display font-bold text-label tracking-label uppercase text-ds-muted ${className}`}
    >
      {children}
    </p>
  )
}
